import React from "react";

export const GlassCard = ({ children, className = "", ...rest }) => (
  <div
    className={`bg-white/40 backdrop-blur-xl border border-white/30 shadow-[0_8px_32px_rgba(0,0,0,0.04)] rounded-[20px] p-6 sm:p-8 ${className}`}
    {...rest}
  >
    {children}
  </div>
);

export default GlassCard;
